export default class FunctionsUtil {

    static verifyResponseNotUndefined(variable: any, condition_1: any, condition_2: any) {
        return variable !== undefined ? condition_1 : condition_2
    }
}